import type { SVGProps } from 'react'
const SvgSyHierarchy = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M18.75 22a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M19 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6M5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
		<path
			d="M4.83 8.02a6.93 6.93 0 0 0 6.54 4.65h.03l3.53-.01c1.52-.02 2.88 1.01 3.29 2.49V17a.76.76 0 1 0 1.52 0V5.78a.76.76 0 1 0-1.52 0v6.62a4.94 4.94 0 0 0-3.28-1.26h-.02l-3.53.01h-.02c-2.29 0-4.34-1.45-5.09-3.62a.76.76 0 0 0-.72-.51c-.08 0-.17.01-.25.04-.41.12-.62.56-.48.96"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyHierarchy
